import { useRef, useCallback } from 'react'
import Shepherd from 'shepherd.js'
import { useFeatureDiscovery } from './useFeatureDiscovery'
import { useAccounts } from './hooks'

const TOUR_DELAY_MS = 5000

export const useAddAccountTour = () => {
  const tourRef = useRef<InstanceType<typeof Shepherd.Tour> | null>(null)
  const { data: accounts } = useAccounts()

  const startTour = useCallback(() => {
    // The tour targets the desktop icon rail, which is hidden on mobile
    if (window.matchMedia('(max-width: 767px)').matches) return

    const accountCount = accounts ? Object.keys(accounts).length : 0
    if (accountCount >= 2) return

    const button = document.getElementById('add-account-button')
    if (!button || tourRef.current?.isActive) return

    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: { enabled: true },
        classes: 'shepherd-theme-custom',
        scrollTo: false
      },
      useModalOverlay: true
    })

    tourRef.current = tour

    tour.addStep({
      id: 'add-account-step',
      text: 'Add another account',
      attachTo: {
        element: '#add-account-button',
        on: 'right'
      },
      buttons: [
        {
          text: 'Exit',
          action: () => tour.cancel(),
          classes: 'shepherd-button-secondary'
        },
        {
          text: 'Add',
          action: () => {
            tour.complete()
            button.click()
          }
        }
      ]
    })

    tour.start()
  }, [accounts])

  const { isFirstTime, markAsSeen } = useFeatureDiscovery('addAccountButton', {
    autoMarkDelay: TOUR_DELAY_MS,
    onAutoMark: startTour
  })

  return { isFirstTime, markAsSeen }
}

export default useAddAccountTour
